import dashboards from "./dashboards";
import accessUsers from "./modules/access-users";
import operations from "./modules/operations";
import content from "./modules/content";
import support from "./modules/support";
import platformSystem from "./modules/platform-system";
import account from "./modules/account";
import financeAnalytics from './modules/finance-analytics'
export default [
  // 1. Dashboard
  ...dashboards,

  // 2. User Management — Roles, Users, Business (businesses + policies)
  ...accessUsers,

  // 3. Operations — Bookings, Products, Services, Deeplinks
  ...operations,

  // 4. Finance & Analytics — enabled when pages are ready
  ...financeAnalytics,

  // 5. Content — CMS, Moderation
  ...content,

  // 6. Support — Tickets, Feedback, Helpdesk
  ...support,

  // 7. Platform & System — Forms, Features, Error Logs
  ...platformSystem,

  // 8. Account — always last
  ...account,
];
